import { useState } from 'react';
import { Alert, Stack, type AlertColor } from '@mui/material';
export interface AppNotice {
  message: string;
  level: number;
}
export function readAppNotices(): AppNotice[] {
  const raw: unknown = JSON.parse(document.getElementById('spa-messages')?.textContent || '[]');
  if (!Array.isArray(raw)) throw new Error('Invalid application notices');
  return raw.map((value: unknown) => {
    if (!value || typeof value !== 'object') throw new Error('Invalid application notice');
    const message: unknown = Reflect.get(value, 'message');
    const level: unknown = Reflect.get(value, 'level');
    if (typeof message !== 'string' || typeof level !== 'number') throw new Error('Invalid application notice');
    return { message, level };
  });
}
export function AppMessages({ messages }: { messages?: AppNotice[] }) {
  const [notices, setNotices] = useState(() =>
    (messages || readAppNotices()).map((notice, index) => ({ ...notice, index })),
  );
  const severity = (level: number): AlertColor =>
    level >= 40 ? 'error' : level >= 30 ? 'warning' : level >= 25 ? 'success' : 'info';
  if (!notices.length) return null;
  return (
    <Stack spacing={2} sx={{ mb: 3 }} aria-label="Application notices">
      {notices.map((notice) => (
        <Alert
          key={notice.index}
          severity={severity(notice.level)}
          onClose={() => setNotices((items) => items.filter((item) => item.index !== notice.index))}
        >
          {notice.message}
        </Alert>
      ))}
    </Stack>
  );
}
